// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createUserAccount } from "@guestsupply/App/Services/RequestWebsiteAccessService";
import { AccountInfoModel, UserAccountModel } from "@guestsupply/XDL/types";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";

export interface CreateAccountsParameter {
    accounts: UserAccountModel[];
    companyName?: string | undefined;
}

type HandlerType = ApiHandler<CreateAccountsParameter & HasOnSuccess<any> & HasOnError<unknown>, AccountInfoModel>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    if (!props.apiParameter.accounts) {
        return;
    }

    try {
        props.apiResult = await createUserAccount(props.apiParameter.accounts);
    } catch (error) {
        props.parameter.onError?.(error);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const createUserAccounts = createHandlerChainRunner(chain, "CreateUserAccounts");

export default createUserAccounts;
